/* eslint-disable no-underscore-dangle */
/** Product inner element component */
/** @param {HTMLElement} element */
function UIProductInnerElement(element) {
  this.__element = element;
}

/**
 * Gets the height of the product
 * @returns {int}
 */
UIProductInnerElement.prototype.getHeight = function getHeight() {
  return this.__element.offsetHeight;
};

/**
 * Sets the height of product
 * @param {int|string} height
 */
UIProductInnerElement.prototype.setHeight = function setHeight(height) {
  this.__element.style.height = height + (typeof height === 'string' ? '' : 'px');
};

module.exports = UIProductInnerElement;
